<template>
  <el-card>
    <div
      slot="header"
      class="clearfix"
    >
      <span>Képviselői áthelyezések</span>
      <el-button
        style="float: right; margin-top: -5px;"
        type="success"
        size="small"
        @click="$router.replace('/representative-processes/representative-replacements/add')"
        icon="el-icon-plus"
        v-can="'representativereplacement.create'"
      >
        Új áthelyezés
      </el-button>
    </div>
    <div v-loading="loading"
      style="min-height: 81px;">
      <table-filter
        v-if="filterConfig"
        :config="filterConfig"
        action="representativeReplacement/fetchAll"
      />
    </div>
    <representative-replacement-list />
    <template v-if="$route.meta.showAddRepresentativeReplacementDialog">
      <representative-replacement-dialog
        type="add"
      />
    </template>
    <template v-if="$route.meta.showUpdateRepresentativeReplacementDialog">
      <representative-replacement-dialog
        :representative-replacement-id="$route.params.id"
        type="update"
      />
    </template>
  </el-card>
</template>

<script>
  import representativeReplacementList from '../../components/representativeProcesses/representativeReplacements/List';
  import representativeReplacementDialog
    from '../../components/representativeProcesses/representativeReplacements/Dialog';
  import TableFilter from '../../components/TableFilter';

  export default {
    components: {
      representativeReplacementList,
      representativeReplacementDialog,
      TableFilter,
    },
    data() {
      return {
        loading: false,
        filterConfig: null,
      };
    },
    async mounted() {
      this.loading = true;
      await this.setConfig();
      this.loading = false;
    },
    methods: {
      async setConfig() {
        let users = this.$store.getters['user/users'];
        if (!users.length) {
          await this.$store.dispatch('user/fetchAll');
          users = this.$store.getters['user/users'];
        }
        this.filterConfig = [
          {
            type: 'select',
            name: 'source_user',
            options: users,
            label: 'Forrás képviselő',
            labelCallback: user => user && `${user.last_name} ${user.first_name} (@${user.username})` || '',
            valueKey: 'id',
            defaultSearch: true,
          },
          {
            type: 'select',
            name: 'target_user',
            options: users,
            label: 'Cél képviselő',
            labelCallback: user => user && `${user.last_name} ${user.first_name} (@${user.username})` || '',
            valueKey: 'id',
          },
        ];
      },
    },
  };
</script>
